<template>
  <div>
    <b-card no-body class="overflow-hidden" style="max-width: 1400px">
      <b-row no-gutters>
        <b-col md="2">
          <b-card-img
            class="imagem-padrao"
            v-if="image"
            :src="image"
          ></b-card-img>
          <div v-else class="cardImage">
            <b-icon icon="card-image" font-scale="4.5"></b-icon>
          </div>
        </b-col>
        <b-col md="7">
          <b-card-body class="title-info">
            {{ type }}
            <b-card-text>
              <div
                :class="{ readLess: readMore == false }"
                class="description-info"
              >
                <p>
                  {{ description }}
                </p>
              </div>
            </b-card-text>
          </b-card-body>
        </b-col>
        <div class="btns">
          <b-col md="2.5">
            <div v-if="readMore == false" class="read-more">
              <button class="btn-read" @click="readMore = !readMore">
                Mostrar mais
              </button>
            </div>
            <div v-else class="read-less">
              <button class="btn-read" @click="readMore = !readMore">
                Mostrar menos
              </button>
            </div>
          </b-col>
          <b-col md="1.5">
            <button class="btn-edit" @click="editProduct">
              <b-icon icon="pencil-fill"></b-icon>
            </button>
          </b-col>
          <b-col md="1.0">
            <button class="btn-edit" @click="excluirProduto">
              <b-icon icon="trash-fill"></b-icon>
            </button>
          </b-col>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import ModalEditProduct from './ModalEditProduct.vue';

export default {
  props: {
    id: Number,
    type: String,
    description: String,
    image: String,
    quantity_kg: Number,
    quantity_plate: Number,
    quantity_unity: Number,
  },
  data() {
    return {
      readMore: false,
      product: {},
    };
  },
  methods: {
    editProduct() {
      this.product = {
        id: this.id,
        type: this.type,
        image: this.image,
        description: this.description,
        quantity_kg: this.quantity_kg,
        quantity_plate: this.quantity_plate,
        quantity_unity: this.quantity_unity,
      };
      const modalEditProduct = new Vue(ModalEditProduct);
      modalEditProduct.product = this.product;
      modalEditProduct.$mount();
      modalEditProduct.$bvModal.show('modal-edit-product');
    },
    excluirProduto() {
      this.$emit('excluirCard', this.id);
    },
  },
};
</script>

<style>
.cardImage {
  background-color: #eeeeee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  border: 1px #5e5e5e;
  border-style: solid;
  color: #be8250;
  padding: 1rem;
  width: 150px;
  height: 150px;
}
.b-row {
  display: flex;
}
.card {
  background-color: transparent;
  border: none;
  padding-bottom: 2rem;
}
.card-body {
  padding-bottom: 1px;
}
.card-img {
  border-radius: 9px;
  border: 1px solid #615f5f;
}
.wrapper-description {
  display: flex;
  align-items: center;
}
.readLess {
  height: 100px;
  overflow: hidden;
}
.btn-read {
  background-color: #d0723e;
  color: white;
  text-align: center;
  margin: 19px 2px;
  padding: 7px, 11px, 7px, 15px;
  border: none;
  border-radius: 19px;
  padding: 7px 15px 7px 15px;
  font-size: 15px;
}
.btn-edit {
  background-color: #615f5f;
  color: white;
  text-align: center;
  margin: 19px 8px 15px 8px;
  border: none;
  border-radius: 40px;
  padding: 7px 12px 7px 12px;
  font-size: 15px;
}
.btns {
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
}

.description-info {
  color: #000;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-top: 6px;
  margin-left: 3px;
}

.title-info {
  color: #000;
  font-family: 'Inter', sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) and (max-width: 1002px) {
  .btns {
    display: inline;
  }
}

.imagem-padrao {
  width: 150px;
  height: 150px;
  object-fit: cover;
}
</style>
